import { usePermission } from '@/hooks/usePermission';
import { useCatalog, useNormCatalog } from '@/lib/quality-catalogs';

import type { CatalogKey, FilterCatalogs } from './components/FilterBar';

// Catálogos de "+ Filtro" de la Lista Maestra (so=430). Sin permiso de catálogos no
// se consultan y el filtro no se ofrece (null); los chips de la URL siguen visibles.

const CATALOGS_READ = 'quality:catalogs:read';

export function useFilterCatalogs(companyId: string | null): FilterCatalogs | null {
  const allowed = usePermission(CATALOGS_READ);
  const scope = { companyId, enabled: allowed };
  const norms = useNormCatalog(scope);
  const types = useCatalog('document-types', scope);
  const areas = useCatalog('process-areas', scope);
  if (!allowed) {
    return null;
  }
  const queries = { norms, types, areas };
  return {
    norms: norms.data,
    types: types.data,
    areas: areas.data,
    failed: { norms: norms.isError, types: types.isError, areas: areas.isError },
    retry: (key: CatalogKey) => void queries[key].refetch(),
  };
}
